const ps = document.querySelectorAll('.gz-text-expanded');
const observer = new ResizeObserver(entries => {
    for (let entry of entries) {
        entry.target.classList[entry.target.scrollHeight > entry.contentRect.height ? 'add' : 'remove']('gz-text-truncated');
    }
});

for (const p of ps) {
    observer.observe(p);
}

const advMediaContainers = document.querySelectorAll(".gz-hub-adv-media[data-ptpurl]");
for (let advMediaContainer of advMediaContainers) {
    let videoScript = document.createElement('script');
    videoScript.src = advMediaContainer.dataset.ptpurl;
    videoScript.setAttribute("defer","defer");
    advMediaContainer.appendChild(videoScript);
    advMediaContainer.removeAttribute('data-ptpurl');
}

for (const el of document.querySelectorAll("a[data-anchor]")) {
    el.addEventListener('click', event => {
        event.preventDefault();
        anchorLink(el.dataset.anchor);
        if (history.pushState) {
            history.pushState(null, null, el.dataset.anchor);
        } else {
            location.hash = el.dataset.anchor.replace('#','');
        }        
    });
}

anchorLink = (anchor) => {
    var element = document.querySelector(anchor),
        offsetPosition = element.offsetTop - 20;

    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
    });
}


 // Se è vodcast, carico subito il player YouTube
let isVodcast = false;
if(document.querySelector('main').classList.contains('gz-vodcast')) {
    isVodcast = true;
}
if (isVodcast) {
    // Adv block youtube video
    let advBlocksYoutube = document.querySelectorAll('.gz-hub-adv-block-youtube');
    if (advBlocksYoutube && advBlocksYoutube.length > 0) {
        window.handleVideos = createYoutubeFacadeManager({
            cardSelector: '.gz-hub-adv-block-youtube .gz-hub-adv-media',
            containerIdPrefix: 'gz-hub-adv-block-'
        });

        createLazyBackgroundObserver({
            containerSelector: '.gz-hub-adv-block-youtube',
            itemSelector: '.gz-hub-adv-media',
            thumbSelector: '.gz-hub-adv-facade',
            rootMargin: '150px 10px 150px 10px',
            threshold: 0.01
        });
    }
}

// Creator video carousel
if (typeof hubHasVideos !== 'undefined' && hubHasVideos) {
    // Vodcast: video facade
    if(isVodcast) {
        window.handleVideos = createYoutubeFacadeManager({
            cardSelector: '.gz-card-creator-video',
            containerIdPrefix: 'gz-creator-video-container-'
        });

        createLazyBackgroundObserver({
            containerSelector: '.gz-swiper-creators',
            itemSelector: '.gz-swiper .gz-card-creator-video',
            thumbSelector: '.gz-video-thumb',
            rootMargin: '150px 10px 150px 10px',
            threshold: 0.01
        });

    }else {
        (handleVideos = () => {
            var hv = handleVideos;
    
            hv.init = () => {
                hv.loadingYT = false;
                hv.loadedYT = false;
                hv.video_players = [];
                // hv.video_play_buttons = document.querySelectorAll('.gz-creator-video-play');
                hv.video_cards = document.querySelectorAll('.gz-card-creator-video');
    
                hv.loadYT();
                hv.loadVideos();
                // hv.bindHandler(); 
            }
    
            hv.loadYT = () => {
                if (!hv.loadedYT && !hv.loadingYT) {
                    mmLoader({
                        src: "https://www.youtube.com/iframe_api",
                        async: true
                    });
                    hv.loadingYT = true;
                }
            }
    
            hv.bindHandler = () => {
                for (const el of hv.video_play_buttons) {
                    el.addEventListener('click', event => {
                        hv.loadVideo(el.dataset.videoid);
                    }, false);
                }
            }
    
            hv.loadVideos = () => {
                for (const el of hv.video_cards) {
                    hv.loadVideo(el.dataset.videoid);
                }
            }
    
            hv.loadVideo = (videoid) => {
                // hv.stopVideos();
                
                // if(!hv.video_players.find(({id}) => id === videoid)){
                    if (hv.loadedYT) {
                        hv.loadingYT = false;
    
                        let player = new YT.Player(`gz-creator-video-container-${videoid}`, {
                            videoId: videoid,
                            events: {
                                'onReady': hv.onPlayerReady,
                                'onStateChange': hv.onPlayerStateChange
                            },
                            playerVars: {
                                mute: 0,
                                /*autoplay: 1,*/
                                modestbranding: 1,
                                showinfo: 0
                            }
                        });
    
                        hv.video_players.push({
                            id: videoid,
                            player
                        });
                    } else {
                        hv.loadYT();
                        setTimeout(function(){
                            hv.loadVideo(videoid);
                        }, 250);
                    }
                /*
                } else {
                    let player = hv.video_players.find(({id}) => id === videoid);
                    player.player.playVideo();
                }
                */
            }
    
            hv.onPlayerReady = (ev) => {
                //console.log(ev.target.getVideoData());
                let videoData = ev.target.getVideoData();
                console.log('[Video carousel onPlayerReady]', videoData.video_id);
            }
    
            hv.onPlayerStateChange = (ev) => {
                if (ev.data == YT.PlayerState.PLAYING) {
                    let videoid = ev.target.getVideoData().video_id;
                    hv.stopOtherVideos(videoid);
                }
            }
    
            hv.setLoaded = () => {
                hv.loadedYT = true;
            }
    
            hv.stopVideos = () => {
                if(hv.video_players.length > 0) {
                    for (const playerObj of hv.video_players) {
                        playerObj.player.stopVideo();
                    }
                }
            }
    
            hv.stopOtherVideos = (videoid) => {
                if(hv.video_players.length > 0) {
                    for (const playerObj of hv.video_players) {
                        if(playerObj.id != videoid){
                            playerObj.player.stopVideo();
                        }
                    }
                }
            }
    
            hv.init();
        })();  
    
        onYouTubeIframeAPIReady = () => {
            handleVideos.setLoaded();
        }
    }
}

// Instagram script loading
let itemsInstagram = document.querySelectorAll('.gz-card-creator-instagram');
if (itemsInstagram && itemsInstagram.length > 0) {
    if (typeof window['instgrm'] === 'undefined') {
        mmLoader({
            src: 'https://www.instagram.com/embed.js',
            async: true
        });
    }
}